import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCSearchBlaffenPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5619" data-mp="1f8dmglsaq2sd">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5620" data-mp="ngej3ectrxpp">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5621" data-mp="ri9gi7rmxqy7">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5622" data-mp="118cj8zok6j9q">
              <XIcon className="w-6 h-6" data-id="element-5623" data-mp="3qksv4prdqnl" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5624" data-mp="8q74j9pxuyua">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-blaffen" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5625" data-mp="2x7yfrrxkyhut"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5626" data-mp="29gklhgfvcc77">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5627" data-mp="20hfowfnvasxo">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5628" data-mp="20ja9ttz52l1r" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5629" data-mp="htwd7nqmjavf">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5630" data-mp="du5p5rshf8ul">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5631" data-mp="11iyeh5elmig8">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5632" data-mp="11gu6ocdkwzao" />
          <div className="hidden md:block" data-id="element-5633" data-mp="wisqq0bg9g3f">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5634" data-mp="wloptrz1aatg">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5635" data-mp="34rqjqjqf85ub">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5636" data-mp="3dq2kvfowym10">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5637" data-mp="2q2ucuq03oyva">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5638" data-mp="27bjnwedxqw61">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5639" data-mp="2fxcol7tpepjs">
        <div className="md:col-span-7" data-id="element-5640" data-mp="2kw7cgo6j34ar">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5641" data-mp="2pxdbf3qs7nsq">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5642" data-mp="2ypyqa8ralaca">
            Ontdek waarom honden blaffen en hoe je dit stopt zonder straffen of
            corrigeren
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5643" data-mp="38oe8fm8cd99n">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5644" data-mp="1j8wtyxbqlpzt">
            <div className="flex -space-x-3" data-id="element-5645" data-mp="1jb16g3npbxbp">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5646" data-mp="f3prv084ec8" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5647" data-mp="3nos3ujp9fsp6" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5648" data-mp="fcdyiwlhf649" />
            </div>
            <div data-id="element-5649" data-mp="2v27cvkcp5im5">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5650" data-mp="2v2qrar351ovf">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5651" data-mp="2q3nm96n5ring">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5652" data-mp="2rl2s2bfs7qcv">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om overmatig
            blaffen van hun hond te begrijpen en verminderen.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5653" data-mp="2nheixobi4mpi">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-5654" data-mp="169fbcwkm6j0w" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5655" data-mp="16apa7nzajv8l" />
                <span className="text-gray-700 font-medium" data-id="element-5656" data-mp="1l7psz1zi8fux">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5657" data-mp="1g60j3po0q88f">
            <div className="flex -space-x-3" data-id="element-5658" data-mp="1u6uv0ia9yrbu">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5659" data-mp="1u5jrmjkqrll9" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5660" data-mp="1yxjm3wi1lmag" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5661" data-mp="28y3lsupwyiqk" />
            </div>
            <div data-id="element-5662" data-mp="3pafw72f21j5j">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5663" data-mp="3p9wbjdy0sgnt">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5664" data-mp="3t9yf5snbfk5q">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5665" data-mp="31jtnra151wv0">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5666" data-mp="31kbp2l2nr19s">
            <div className="flex justify-center items-center w-full" data-id="element-5667" data-mp="35l5czeg3og2o">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-blaffen" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5668" data-mp="3ac40oz3f4gfy"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5669" data-mp="1wciw9dndzfzj">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5670" data-mp="1wbr309h9hucf">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5671" data-mp="1rd64cehnriq3">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5672" data-mp="1ml63mjtrklsg">
            <div className="flex flex-col items-center" data-id="element-5673" data-mp="1hmuxaj2ogtez">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5674" data-mp="1hla1yr8jh6g2" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5675" data-mp="13nbpxshoxm3q">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5676" data-mp="1rppk01d5n6bu">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5677" data-mp="1nn2p1rl6t5af">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5678" data-mp="21fit8vptr9cx" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5679" data-mp="18rwj14m3d6h3">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5680" data-mp="14prs4dn12ny5">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5681" data-mp="1dpy1poflv3s1">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5682" data-mp="1dod6dwlgvgt4" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5683" data-mp="axlnzn0tlopv">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5684" data-mp="azonqyrryw7s">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5685" data-mp="1y8fawkit467">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5686" data-mp="kvjbu9erpjhy">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5687" data-mp="kuqfm2dfqce2">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5688" data-mp="pucojzm8d6h2">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-5689" data-mp="1ianhk91r8urd" />
            <span className="italic" data-id="element-5690" data-mp="1ib5ktpmu498s">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5691" data-mp="1s5kyamj3e6i6">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5692" data-mp="1n82neqlilh7j">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5693" data-mp="1n5yl2d39kq9d">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5694" data-mp="1d8tvs4e4geoc"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5695" data-mp="liz4w3am8gxk">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5696" data-mp="2x4ra0njtypl2">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5697" data-mp="366haeivowyuz"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5698" data-mp="1urllm43bxh0p">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5699" data-mp="1uphktv0q8y4n">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5700" data-mp="5azw4aqqzylj"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5701" data-mp="t00vz9lim1f7">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5702" data-mp="sxofz1zbi14s">
              <div className="flex items-center mb-4" data-id="element-5703" data-mp="2zqh6bk7dkhjr">
                <div className="flex text-green-500 mr-2" data-id="element-5704" data-mp="2urntzv3tqwl6">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5705" data-mp="1aa4ssaj075ra" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5706" data-mp="1f6v82vmzhxbn">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5707" data-mp="11fqhej1lgfdg">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5708" data-mp="ri2j5j4s4pqj">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5709" data-mp="3pu8lvs9nalfl">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5710" data-mp="3kucjfxglj225">
              <div className="flex items-center mb-4" data-id="element-5711" data-mp="3gt0pxgulpwoo">
                <div className="flex text-green-500 mr-2" data-id="element-5712" data-mp="3gvn4w1jtnegx">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5713" data-mp="cfkkm5xsdbbs" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5714" data-mp="8e8r3pbsk5yb">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5715" data-mp="3n0kt25rd0pd">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5716" data-mp="3uud1lg2qbc4r">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5717" data-mp="1cpbwaxz6z7d7">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5718" data-mp="1mlyfzjfs7sdn">
              <div className="flex items-center mb-4" data-id="element-5719" data-mp="1mjlpghvyk9oz">
                <div className="flex text-green-500 mr-2" data-id="element-5720" data-mp="1rdzpixlkf4zz">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5721" data-mp="1wb8af5y3ln4x" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5722" data-mp="20f69xhrc4zyi">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5723" data-mp="25czbfxhp15sg">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5724" data-mp="2lotegk6ud08v">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5725" data-mp="1p5dnmli6lyg9">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5726" data-mp="1k72eye3mhtzm">
              <div className="flex items-center mb-4" data-id="element-5727" data-mp="3vt389meeuudm">
                <div className="flex text-green-500 mr-2" data-id="element-5728" data-mp="4gia12k6rbum">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5729" data-mp="3lx9lla6z9ki4" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5730" data-mp="3qwmhsljqo3xd">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5731" data-mp="igt1o7tbkugu">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5732" data-mp="ncruc7lokyn2">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5733" data-mp="2u4sopdw8bfb8">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5734" data-mp="2y88gnwxcsrhl">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5735" data-mp="1vh3zofp7xfks">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5736" data-mp="1vg1coiv0nxa5">
          <div data-id="element-5737" data-mp="1gry0grqdrpcw">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5738" data-mp="1grel9is47f2k">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5739" data-mp="17s1kdei23ytg">
              <p data-id="element-5740" data-mp="17pov0g9yym6d">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-5741" data-mp="j63lu5e31gtu">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-5742" data-mp="125hiww73z7ok">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-5743" data-mp="1gudpspxfienl">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-5744" data-mp="1xu6odq5yyxrn">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5745" data-mp="2bllai5v6bf2x">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5746" data-mp="2glr3pqh3d9n4" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5747" data-mp="r8dx1ulib9iu">
        <div className="max-w-md mx-auto px-4" data-id="element-5748" data-mp="r95tf7mxhba6">
          <div className="p-6 rounded-3xl w-full" data-id="element-5749" data-mp="jov7t6lo6k1t">
            <div className="flex justify-center items-center" data-id="element-5750" data-mp="jpmwdxgunhil">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-optin-blaffen" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5751" data-mp="evimb5caetda"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5752" data-mp="npngnyqmqmxk">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5753" data-mp="nrhsmnjxb4pi">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5754" data-mp="3dg0mwyjh4rl0" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5755" data-mp="15uw3hs1nyvwl">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5756" data-mp="r718g506ofgc">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5757" data-mp="1jv6viyepmgjc">
            <p className="mb-2" data-id="element-5758" data-mp="1jt2t6kwglpl6">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5759" data-mp="19wzpvbpvfkwn">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5760" data-mp="2qntkaqw59c78" />
    </div>;
}